exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".hamburger[data-v-4e6f274c] {\n  display: inline-block;\n  vertical-align: middle;\n  /* position: relative;\n  left: 27px;\n  top: 35.12px; */\n  width: 26.04px;\n  height: 19.75px;\n}\n.hamburger.is-active[data-v-4e6f274c] {\n  -webkit-transform: rotate(180deg);\n          transform: rotate(180deg);\n}\n", ""]);

// exports
